import { render, staticRenderFns } from "./NotificationPreferences.vue?vue&type=template&id=3ae156be&scoped=true"
import script from "./NotificationPreferences.vue?vue&type=script&lang=js"
export * from "./NotificationPreferences.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreferences.vue?vue&type=style&index=0&id=3ae156be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae156be",
  null
  
)

export default component.exports